export default __webpack_public_path__ + "static/media/894.036e3c5b.png";